export default "__VITE_ASSET__bb205bd6__"